module.exports = __webpack_public_path__ + "48bd1dfe84af8011c1b531461cb0d6d4.svg";